import React, { useMemo } from "react";
import { Footer, TranslatedString } from "@bosch/bt-ui";
import { Container, Row, Col } from "react-bootstrap";
import withErrorHandler from "./ErrorHandler";

const MainFooter = () => {
  const shouldShowVersionInFooter = false;

  const footerCopyrightSection = useMemo(() => {
    let myVersion = null;

    if (shouldShowVersionInFooter) {
      myVersion = {
        label: <TranslatedString stringId="Version" />,
        text: "insert app version here",
      };
    }

    return {
      copyrightsText: `© Radionix B.V. 2026`,
      version: myVersion,
    };
  }, [shouldShowVersionInFooter]);

  const environment = MOBY_ENV || "prod";

  const links = {
    termsOfUse:
      environment === "test"
        ? "https://serviceportal.radionix.com/us/termsAndConditions"
        : "https://serviceportal.radionix.com/us/termsAndConditions",
    privacyNotice:
      environment === "test"
        ? "https://serviceportal.radionix.com/us/privacyPolicy"
        : "https://serviceportal.radionix.com/us/privacyPolicy",
    corporateInfo:
      environment === "test"
        ? "https://serviceportal.radionix.com/us/imprint"
        : "https://serviceportal.radionix.com/us/imprint"
  };

  return (
    <footer className="bg-light text-center text-lg-start">
      <Container fluid className="p-3">
        <Row>
          <Col>
            <p className="mb-1">{footerCopyrightSection.copyrightsText}</p>
            <p className="mb-1">
              <a
                href={links.termsOfUse}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Use
              </a>{" "}
              |{" "}
              <a
                href={links.privacyNotice}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Notice
              </a>{" "}
              |{" "}
              <a
                href={links.corporateInfo}
                target="_blank"
                rel="noopener noreferrer"
              >
                Corporate Information
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default withErrorHandler(React.memo(MainFooter));
